export default __webpack_public_path__ + "static/media/brand_creditos_directos.ba423d8b.png";